import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { Toaster } from './components/ui/sonner';
import Login from './pages/Auth/Login';
import LoginLoading from './pages/Auth/LoginLoading';
import DashboardLayout from './pages/Layout/DashboardLayout';
import Billing from './pages/Dashboard/Billing';
import Cart from './pages/Cart/Cart';
import SubscriptionsList from './pages/Subscriptions/SubscriptionsList';
import PaymentHistory from './pages/Payments/PaymentHistory';
import ProductList from './pages/Products/ProductList';
import BillingInfo from './pages/Settings/BillingInfo';
import SystemStatus from './pages/Status/SystemStatus';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div className="loading-screen">Cargando...</div>;
  }
  
  return user ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/auth/key/:token" element={<LoginLoading />} />
            <Route path="/status" element={<SystemStatus />} />
            
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Navigate to="/dashboard/billing" />} />
              <Route path="billing" element={<Billing />} />
              <Route path="cart" element={<Cart />} />
              <Route path="subscriptions" element={<SubscriptionsList />} />
              <Route path="payments" element={<PaymentHistory />} />
              <Route path="products" element={<ProductList />} />
              <Route path="billing-info" element={<BillingInfo />} />
            </Route>
            
            <Route path="/" element={<Navigate to="/dashboard/billing" />} />
            <Route path="*" element={<Navigate to="/dashboard/billing" />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;